import { Card } from "primereact/card";
import { JVDate } from "../../shared/JVDate";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Button } from "primereact/button";
import React, { useEffect, useRef, useState } from "react";
import { IBranchMastDropdown, ICompanyMastDropdown, IUsersDropdown } from "../../models/IDropdown";
import { Fetch, baseUrl } from "../../shared/Fetch";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { ILogin, IPermissionProps } from "../../models/Login";

interface ISubVendorPerformanceReports {
    from_Date?: Date | null,
    to_Date?: Date | null,
    sub_Vendor?: string | null,
    company?: number | null,
    branch?: number | null,
    recruiter?: number | null,
    isFilter?: number | null,
    frequency?: number | null,
}

interface ISubVendorPerformanceReportsTableData {
    vendor_Company_ID: string,
    vendor_Company_Name: string,
    req: number,
    sub: number,
    subEnd: number,
    eCI: number,
    pO: number,
}

const EmptySubVendorPerformanceReports: ISubVendorPerformanceReports = {
    from_Date: new Date(),
    to_Date: new Date(),
    sub_Vendor: "",
    company: null,
    // branch: null,
    // recruiter: null,
}

const schema = yup.object({
    fromDate: yup.date().nullable(),
    toDate: yup.date().nullable(),
    sub_Vendor: yup.string().required("Sub Vendor Company"),
    company: yup.number().nullable(),
});

export const AllSubVendorPerformanceReports = (permissions: IPermissionProps) => {
    // const [loading, setloading] = useState(false);
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ISubVendorPerformanceReportsTableData>, loading: boolean });
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [recruiters, setRecruiters] = useState<Array<IUsersDropdown>>();
    const [shwTable, setShwTable] = useState(false);
    const [loadIcon, setLoadIcon] = useState(false);
    const [shwSubTable, setShwSubTable] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean });
    const [filter, setFilter] = useState<ISubVendorPerformanceReports>(EmptySubVendorPerformanceReports);
    const [tFooter, setTFooter] = useState<any>({});
    const [excel, setExcel] = useState<boolean>(false);
    const [excelNum, setExcelNum] = useState<number | null>(0);
    const [excelLoading, setExcelLoading] = useState<boolean>(false);
    const dt = useRef<any>(null);
    const toast = useRef<any>(null);

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<ISubVendorPerformanceReports>({
        resolver: yupResolver(schema),
        defaultValues: EmptySubVendorPerformanceReports,
        shouldFocusError: false
    });

    const loadCompanies = async () => {
        const response = await Fetch("Dropdown/company", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            const lastData = {
                company_ID: -1,
                company_Name: "Vyze + Vyze2"
            };
            data.unshift(emptyData);
            data.push(lastData);
            setCompanies(data);
        }
    }
    // const loadBranches = async (company?: number | null | undefined) => {
    //     let queryParam = company ? `company_id=${company}` : null;
    //     const response = await Fetch("Dropdown/filterBranchList", "GET", null, queryParam, null);
    //     if (response) {
    //         const data: Array<IBranchMastDropdown> = await response.json();
    //         const emptyData = {
    //             branch_ID: 0,
    //             branchName: "-- SELECT --",
    //             company_ID: 0
    //         };
    //         data.unshift(emptyData);
    //         setBranches(data);
    //     }
    // }
    // const loadRecruiters = async (branch: number | null | undefined, company: number | null | undefined) => {
    //     let queryParameter = null;
    //     if (branch != 0 && branch != null) {
    //         queryParameter = `branch_ID=${branch}`;
    //     } else if (company != 0 && company != null) {
    //         queryParameter = `company_ID=${company}`;
    //     }

    //     const response = await Fetch("Dropdown/filterUsersList", "GET", null, `user_Type=recruiter&${queryParameter}`, null);
    //     if (response) {
    //         const data: Array<IUsersDropdown> = await response.json();
    //         const emptyData = {
    //             login_ID: 0,
    //             user_Name: "-- SELECT --"
    //         };
    //         data.unshift(emptyData);
    //         setRecruiters(data);
    //     }
    // }

    const loadData = async (data: ISubVendorPerformanceReports) => {
        if (data.sub_Vendor != null && data.sub_Vendor?.trim() !== "") {
            setTableData({ tableData: tableData.tableData, loading: true });
            setLoadIcon(true);
            const response = await Fetch("SubVendorPerformanceReports/getAllSubVendorRprt", "GET", null, `filter=${JSON.stringify(data)}`, null);
            if (response) {
                const data = await response.json();
                let totalNoOfReqSales = 0;
                let totalNoOfReqPV = 0;
                let totalNoOfSub = 0;
                let totalNoOfSubClient = 0;
                let totalNoOfECI = 0;
                let totalNoOfPO = 0;

                data.forEach((d: { rejected_Sales: number; rejected_PV: number; sub: number; subEnd: number; eci: number; po: number; }, i: any) => {
                    if (d.rejected_Sales) totalNoOfReqSales += d.rejected_Sales;
                    if (d.rejected_PV) totalNoOfReqPV += d.rejected_PV;
                    if (d.sub) totalNoOfSub += d.sub;
                    if (d.subEnd) totalNoOfSubClient += d.subEnd;
                    if (d.eci) totalNoOfECI += d.eci;
                    if (d.po) totalNoOfPO += d.po;
                });

                const totalRecords: any = {
                    total: "Total Records",
                    noOfReqSales: totalNoOfReqSales,
                    noOfReqPV: totalNoOfReqPV,
                    noOfSub: totalNoOfSub,
                    noOfSubClient: totalNoOfSubClient,
                    noOfECI: totalNoOfECI,
                    noOfPO: totalNoOfPO
                };
                setTFooter(totalRecords);
                setTableData({ tableData: data, loading: false });
                setLoadIcon(false);
            } else {
                setTableData({ tableData: tableData.tableData, loading: false });
                setLoadIcon(false);
            }
        } else {
            toast.current.show({ severity: 'error', detail: "Enter Sub Vendor Company Name", life: 3000 });
        }
    }

    useEffect(() => {
        // loadRecruiters(0, 0);
        loadCompanies();
        // loadBranches();
        // loadData();
    }, []);

    // useEffect(() => {
    //     const subscription = watch((value, { name, type }) => {
    //         if (name === "company") {
    //             if (value.company != 0) {
    //                 loadBranches(value.company);
    //                 loadRecruiters(0, value.company);
    //             } else {
    //                 loadBranches();
    //                 if (value.branch != 0) {
    //                     loadRecruiters(value.branch, 0);
    //                 } else {
    //                     loadRecruiters(0, 0);
    //                 }
    //             }
    //         }

    //         if (name === "branch") {
    //             if (value.branch != 0) {
    //                 loadRecruiters(value.branch, 0);
    //             } else {
    //                 if (value.company != 0) {
    //                     loadRecruiters(0, value.company);
    //                 } else {
    //                     loadRecruiters(0, 0);
    //                 }
    //             }
    //         }

    //         if (name === "frequency") {
    //             if (value.frequency != 0 && value.frequency != null) {
    //                 setExcelNum(prev => prev = value?.frequency || 0);
    //                 setExcel(prev => prev = true);
    //             } else {
    //                 setExcel(prev => prev = false);
    //                 setExcelNum(prev => prev = null);
    //             }
    //         }
    //     });

    //     return () => subscription.unsubscribe();
    // }, [watch]);

    const onSubmit = (data: ISubVendorPerformanceReports) => {
        let newDate = new Date;
        if (data.from_Date?.toDateString() !== newDate.toDateString() || (data.sub_Vendor !== null && data.sub_Vendor !== "") || (data.company !== null && data.company !== 0) || (data.branch !== null && data.branch !== 0) || (data.recruiter !== null && data.recruiter !== 0)) {
            data.isFilter = 1;
        } else {
            data.isFilter = null;
        }
        delete data.frequency;
        setShwTable(true);
        loadData(data);
        setFilter(data);
    };

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const hideDialog = () => {
        setShwSubTable({ singleData: {}, open: false });
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">All Sub Vendor Performance Reports</h5>
            {/* <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Button icon="pi pi-filter" onClick={() => setFilter(true)} className="p-button-rounded p-button-secondary ml-2" aria-label="Filter" />
            </span> */}
            <React.Fragment>
                {permissions.is_Export && <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />}
            </React.Fragment>
        </div>
    );
    const downloadExcel = async (data: ISubVendorPerformanceReports, exceltype: number) => {
        setExcelLoading(p => p = true);
        const params = {
            method: "GET",
            headers: {
                'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            }
        };
        try {
            const response = await fetch(`${baseUrl}${"SubVendorPerformanceReports/getexcel"}?` + `filter=${JSON.stringify(data)}` + `&exceltype=${exceltype}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = `SubVendorPerformanceReports.xlsx`;
                a.href = href;
                a.click();
                a.href = '';
                setExcelLoading(p => p = false);
            } else if (response.status === 400) {
                const message = await response.text();
                toast.current.show({ severity: 'error', detail: message, life: 3000 });
                setExcelLoading(p => p = false);
            }
        } catch {
            setExcelLoading(p => p = false);
            toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    }

    const onSubmitForExcel = (data: ISubVendorPerformanceReports) => {
        let newDate = new Date;
        if (data.from_Date?.toDateString() !== newDate.toDateString() || (data.sub_Vendor !== null && data.sub_Vendor !== "") || (data.company !== null && data.company !== 0) || (data.branch !== null && data.branch !== 0) || (data.recruiter !== null && data.recruiter !== 0)) {
            data.isFilter = 1;
        } else {
            data.isFilter = null;
        }
        downloadExcel(data, excelNum || 0);
    };

    const onClear = () => {
        reset(EmptySubVendorPerformanceReports);
        setExcelLoading(p => p = false);
        setExcel(prev => prev = false);
        setExcelNum(prev => prev = null);
    }

    // useEffect(() => {
    //     loadData(EmptySubVendorPerformanceReports);
    // }, []);

    return (
        <>
            <Card>
                <form onSubmit={handleSubmit(excel === true ? onSubmitForExcel : onSubmit)} className="p-fluid formgrid grid">
                    <JVDate maxDate={new Date} column={6} label="From Date" control={control} name="from_Date" />
                    <JVDate maxDate={new Date} column={6} label="To Date" control={control} name="to_Date" />
                    <JVInput required column={6} label="Sub Vendor:" control={control} name="sub_Vendor" placeholder="Enter Sub Vendor" error={errors.sub_Vendor?.message} />
                    {!_roles.includes(4) && <JVDropdown column={6} label="Company" control={control} name="company" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />}
                    {/* {!_roles.includes(4) && <JVDropdown column={6} label="Branch" control={control} name="branch" options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" />} */}
                    {/* <JVDropdown column={6} label="Recruiter" control={control} name="recruiter" options={recruiters} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Recruiter" /> */}
                    {/* {(_roles.includes(1) || _roles.includes(20) || _roles.includes(26)) && <JVDropdown column={6} label="Frequency" control={control} name="frequency" options={[{ label: "--SELECT--", value: 0 }, , { label: "Daily", value: 4 }, { label: "Weekly", value: 1 }, { label: "Monthly", value: 2 }, { label: "Quarterly", value: 3 }]} optionLabel="label" optionValue="value" placeholder="Select Type Of Excel" />} */}
                    <div className="col-12 md:col-12">
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px' }}>
                            {!excel && <Button className="field col-12 md:col-6" label="FIND" type="submit" loading={loadIcon}></Button>}
                            {excel && <Button className="field col-12 md:col-6" loading={excelLoading} disabled={excelLoading} style={{ backgroundColor: "#9c27b0" }} label="GET EXCEL" type="submit" ></Button>}
                            <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={onClear} type="button"></Button>
                        </div>
                    </div>
                </form>
            </Card>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                resizableColumns showGridlines columnResizeMode="expand"
                ref={dt} size="small" stripedRows scrollable scrollHeight="70vh"
                value={tableData.tableData}
                header={header}
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} style={{ maxWidth: '4rem' }} />
                <Column field="vendor_Company_Name" header="Sub Vendor" sortable footer={tFooter.total} />
                <Column field="sub" header="Sub" footer={tFooter.noOfSub} />
                <Column field="rejected_Sales" header="Rejected Sales" sortable footer={tFooter.noOfReqSales} />
                <Column field="rejected_PV" header="Rejected PV" footer={tFooter.noOfReqPV} />
                <Column field="subEnd" header="Sub End Client" footer={tFooter.noOfSubClient} />
                <Column field="eci" header="ECI" footer={tFooter.noOfECI} />
                <Column field="po" header="PO" footer={tFooter.noOfPO} />
            </DataTable>
            <Toast ref={toast} />
        </>
    );
}